<script>
// renderless component
// Hacky way to emit values change from slotscope
import { watch, toRefs, defineComponent } from 'vue';
import { isEqual } from 'lodash-es';

export default defineComponent({
  props: {
    values: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
  },
  emits: ['change', 'error'],
  setup(props, { emit }) {
    const { values, errors } = toRefs(props);
    watch(
      values,
      (nv, ov) => {
        if (ov !== undefined) {
          !isEqual(nv, ov) && emit('change', nv);
        } else {
          // console.log('首次设置value，不emit change');
        }
      },
      { immediate: true, deep: true }
    );

    watch(
      errors,
      (nv, ov) => {
        if (ov !== undefined) {
          !isEqual(nv, ov) && emit('error', nv);
        } else {
          // console.log('首次设置value，不emit change');
        }
      },
      { immediate: true, deep: true }
    );
    return () => null;
  },
});
</script>
<style lang="less" scoped></style>
